// ============================================
// History / Story Log
// ============================================

import { events, Events } from '../engine/events.js';
import { L } from '../systems/localization.js';

const storyHistory = [];
let _scope = null;

export const historyUI = {
    init() {
        if (!_scope) _scope = events.createScope('history');
        // Record dialogue lines. Store the lineId (Ink #id: tag) so render()
        // can translate via L.get(lineId) at display time — keeps the log in
        // sync with the current language even after a mid-session switch.
        _scope.on(Events.STORY_DIALOGUE, (speaker, text, portrait, lineId) => {
            if (text && text.trim()) {
                storyHistory.push({
                    text: text.trim(),
                    speaker: speaker || null,
                    lineId: lineId || null,
                    time: Date.now(),
                });
                if (storyHistory.length > 200) storyHistory.shift();
            }
        });
        // Record narration/info text
        _scope.on(Events.STORY_INFO_TEXT, (text, lineId) => {
            if (text && text.trim()) {
                storyHistory.push({
                    text: text.trim(),
                    speaker: null,
                    lineId: lineId || null,
                    time: Date.now(),
                });
                if (storyHistory.length > 200) storyHistory.shift();
            }
        });
        // Reset the log on every new-game / load. storyHistory is module-level
        // and historyUI.init() only runs once at boot, so without this the
        // previous run's lines bled into a freshly started or loaded game.
        // SCREEN_CHANGE -> 'screen-game-view' is the new-game/load signal used
        // across the codebase (character-editor start, save-load, continue).
        _scope.on(Events.SCREEN_CHANGE, (screen) => {
            if (screen === 'screen-game-view') storyHistory.length = 0;
        });
    },

    destroy() {
        if (_scope) {
            _scope.destroy();
            _scope = null;
        }
    },

    /** Translate via lineId key. Falls back to original (English) text. */
    _l10n(lineId, text) {
        return L.translateLine(lineId, text);
    },

    render() {
        const content = document.getElementById('history-content');
        if (!content) return;
        content.innerHTML = '';

        if (storyHistory.length === 0) {
            const empty = L.get('history.empty');
            const txt = empty !== 'history.empty' ? empty : 'No story history yet.';
            content.innerHTML = '<div style="text-align:center;color:var(--text-faint);padding:32px;font-size:12px;">' + txt + '</div>';
            return;
        }

        // Show most recent first
        for (let i = storyHistory.length - 1; i >= 0; i--) {
            const entry = storyHistory[i];
            const localized = this._l10n(entry.lineId, entry.text);
            const el = document.createElement('div');
            el.className = 'history-entry';
            if (entry.speaker) {
                const speakerSpan = document.createElement('span');
                speakerSpan.className = 'history-speaker';
                speakerSpan.textContent = `${entry.speaker}:`;
                el.appendChild(speakerSpan);
                el.appendChild(document.createTextNode(` ${localized}`));
            } else {
                el.textContent = localized;
            }
            content.appendChild(el);
        }
    }
};
